import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Check,
  ArrowRight,
  Sparkles,
  Award,
  Plane,
  GraduationCap,
  Percent,
  Smartphone,
  Flame,
  Waves,
  Users,
  Clock,
  Star,
  Copy,
  BookOpen,
  Trophy,
  Users2,
  Zap,
  Lock,
  Unlock,
  ChevronDown,
} from "lucide-react";
import { WinnerModal } from "../components/site/WinnerSection";
import LegalDocsFooter from "../components/site/LegalDocsFooter";
import { IMG } from "@/data/content";

/* ============================================================
   ÁREA EDITÁVEL
   ============================================================ */
const WHATSAPP_GROUP_LINK =
  "https://chat.whatsapp.com/DQWqi1uziSk90WektD0Q7n?s=cl&p=a&mlu=0&amv=1";
const HERO_IMG = "/images/couple-diving-new.jpg";
/* ============================================================ */

const EASE = [0.16, 1, 0.3, 1];

const revealProps = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: EASE },
};

const DISCOVER = [
  {
    icon: Waves,
    emoji: "🐋",
    title: "Expedição para Abrolhos",
    text: "Uma expedição completa para você e um acompanhante, com todas as despesas pagas. Todos os membros do clube participam do sorteio.",
    img: "https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=1000&auto=format&fit=crop&q=75",
    status: "revealed",
    statusLabel: "Sorteio realizado 26/07 — já saiu o ganhador!",
  },
  {
    icon: GraduationCap,
    emoji: "🎓",
    title: "Curso de mergulho para 2",
    text: "Curso completo para 2 membros do clube. Concorrem apenas os 100 primeiros a entrar — seja rápido, as vagas são por ordem de entrada.",
    img: "https://images.unsplash.com/photo-1682687982501-1e58ab814714?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Em breve",
  },
  {
    icon: Waves,
    emoji: "🏝️",
    title: "Expedição para Paraty",
    text: "Ao atingirmos 300 membros no clube: viagem para Paraty para 2 pessoas, com todas as despesas pagas. Todos os membros do clube participam do sorteio.",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera ao atingir 300 membros",
  },
  {
    icon: Sparkles,
    emoji: "🎁",
    title: "Conhecer Dubai (Prêmio Surpresa)",
    text: "Conheça Dubai e mergulhe na piscina mais funda do mundo — para você e um acompanhante, com todas as despesas pagas. Exclusivo para as 500 primeiras pessoas a entrar no clube — seja rápido!",
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera com as 500 primeiras",
  },
  {
    icon: Plane,
    emoji: "🏆",
    title: "Tailândia (Grande Prêmio)",
    text: "Ao atingirmos 2.000 membros no clube: viagem para a Tailândia para você e um acompanhante, com todas as despesas pagas. Todos os membros do clube participam do sorteio.",
    img: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera ao atingir 2.000 membros",
  },
  {
    icon: Waves,
    emoji: "🏖️",
    title: "Hospedagem de frente pro mar",
    text: "Hospedagem com mergulho para credenciado ou batismo incluso. Todos os membros do clube participam do sorteio.",
    img: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Em breve",
  },
  {
    icon: Sparkles,
    emoji: "🎉",
    title: "E muito mais prêmios ao longo do ano",
    text: "Novos prêmios serão liberados no decorrer de 1 ano dentro do clube — e você participa automaticamente de todos.",
    img: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Novos prêmios ao longo do ano",
  },
];

const BENEFITS = [
  "20% OFF no Batismo",
  "R$ 800 OFF em qualquer curso",
  "R$ 1.000 OFF em Abrolhos",
  "R$ 1.000 OFF em Paraty",
  "R$ 1.000 OFF em Recife",
  "R$ 500 OFF em futuras expedições nacionais",
  "R$ 1.000 OFF em expedições internacionais",
  "20% OFF em equipamentos Cressi",
  "Acesso antecipado ao DiverTrack Premium",
  "Novos benefícios durante o ano",
];

const REASONS = [
  { icon: Star, title: "Vantagens exclusivas", text: "Primeiros membros terão vantagens exclusivas." },
  { icon: Sparkles, title: "Novidades em primeira mão", text: "Novidades serão reveladas primeiro no grupo." },
  { icon: Flame, title: "Desde o início", text: "Você participa desde o início do projeto." },
  { icon: Clock, title: "Vagas limitadas", text: "As oportunidades são limitadas." },
];

function WhatsIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.2-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.412-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.463 3.488" />
    </svg>
  );
}

function GreenCTA({ children, className = "", size = "lg" }) {
  const sizes = size === "xl"
    ? "px-10 py-6 text-lg sm:text-xl"
    : "px-8 py-5 text-base sm:text-lg";
  return (
    <motion.a
      href={WHATSAPP_GROUP_LINK}
      target="_blank"
      rel="noreferrer"
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      onClick={() => {
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
          window.fbq("trackCustom", "click_join_vip_group");
        }
      }}
      className={`inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#25D366] font-extrabold uppercase tracking-wide text-white shadow-2xl shadow-[#25D366]/40 transition-transform sm:w-auto ${sizes} ${className}`}
      data-testid="cta-join-vip"
    >
      <WhatsIcon className="h-6 w-6" />
      {children}
      <ArrowRight className="h-5 w-5" />
    </motion.a>
  );
}

function CopyLinkButton({ testId = "copy-vip-link-btn" }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(WHATSAPP_GROUP_LINK);
    } catch {
      const el = document.createElement("textarea");
      el.value = WHATSAPP_GROUP_LINK;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", "copy_vip_group_link");
    }
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-semibold text-white/80 backdrop-blur transition-colors hover:border-[#7BE0D6]/40 hover:bg-white/10 hover:text-white sm:text-sm"
      data-testid={testId}
      aria-live="polite"
    >
      {copied ? (
        <>
          <Check className="h-4 w-4 text-[#7BE0D6]" />
          Link copiado! Cole no WhatsApp Business
        </>
      ) : (
        <>
          <Copy className="h-4 w-4" />
          Usa WhatsApp Business? Copiar link do grupo
        </>
      )}
    </button>
  );
}

export default function ParticiparDoClube() {
  const [winnerOpen, setWinnerOpen] = useState(false);
  const [regulamentoOpen, setRegulamentoOpen] = useState(false);

  useEffect(() => {
    document.title = "Grupo VIP · Clube Dive Master";
  }, []);

  return (
    <main className="relative w-full overflow-x-hidden bg-[#02081F] text-white">
      {/* ================== HERO ================== */}
      <section className="relative flex min-h-[100svh] items-center overflow-hidden">
        <img
          src={HERO_IMG}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(2,8,31,0.55) 0%, rgba(2,8,31,0.75) 60%, rgba(2,8,31,0.95) 100%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background: "radial-gradient(ellipse at 30% 30%, rgba(59,130,246,0.25), transparent 60%)",
          }}
        />

        <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-6 py-14 text-center sm:py-24">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.28em] text-white/85 backdrop-blur"
          >
            <Sparkles className="h-3.5 w-3.5 text-[#7BE0D6]" /> Grupo VIP Dive Master
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
            className="mt-6 font-display text-4xl font-black uppercase leading-[0.98] tracking-tight sm:text-5xl lg:text-6xl"
          >
            O maior projeto da história da{" "}
            <span className="text-[#7BE0D6]">Dive Master</span> acaba de começar.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35, ease: EASE }}
            className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg"
          >
            Entre <strong className="font-bold text-white">gratuitamente</strong> no grupo VIP e
            descubra como concorrer a expedições incríveis, economizar milhares de reais em
            mergulho e fazer parte da comunidade que está transformando a forma de viver o oceano.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.55, ease: EASE }}
            className="mt-10 flex w-full flex-col items-center sm:w-auto"
          >
            <GreenCTA size="xl">Quero entrar no grupo VIP</GreenCTA>
            <CopyLinkButton testId="copy-vip-link-hero" />
          </motion.div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70">
            {["Grupo silencioso", "Sem spam", "Entrada gratuita"].map((t) => (
              <li key={t} className="flex items-center gap-1.5">
                <Check className="h-4 w-4 text-[#7BE0D6]" /> {t}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ================== O QUE VOCÊ VAI CONCORRER ================== */}
      <section className="relative px-6 py-24 sm:py-32">
        <motion.div {...revealProps} className="mx-auto max-w-3xl text-center">
          <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
            Sorteio exclusivo do grupo
          </p>
          <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl">
            Entrando no clube você concorre:
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
            Suas chances são <strong className="font-bold text-white">altíssimas</strong> — são
            pouquíssimas pessoas participando. Basta estar no grupo VIP para conferir as
            informações e concorrer.
          </p>
        </motion.div>

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {DISCOVER.map((c) => {
            const isLocked = c.status === "locked";
            const isActive = c.status === "active";
            const isRevealed = c.status === "revealed";
            return (
              <motion.div
                key={c.title}
                {...revealProps}
                className={`group relative overflow-hidden rounded-3xl border backdrop-blur-md transition-colors ${
                  isActive || isRevealed
                    ? "border-[#F5C542]/70 bg-[#F5C542]/[0.06] shadow-2xl shadow-[#F5C542]/20"
                    : "border-white/10 bg-white/5 hover:border-white/20"
                }`}
              >
                {c.img && (
                  <div className="relative aspect-[16/10] w-full overflow-hidden">
                    <img
                      src={c.img}
                      alt={c.title}
                      loading="lazy"
                      className={`h-full w-full object-cover transition-all duration-700 group-hover:scale-105 ${
                        isLocked ? "grayscale-[0.6] brightness-[0.55]" : ""
                      }`}
                    />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#02081F] via-[#02081F]/20 to-transparent" />
                    <span className="absolute left-4 top-4 text-3xl drop-shadow-lg">{c.emoji}</span>

                    {/* Padlock badge — locked prizes */}
                    {isLocked && (
                      <div className="absolute right-3 top-3 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-[#02081F]/85 backdrop-blur-md">
                        <Lock className="h-5 w-5 text-white/85" strokeWidth={2.4} />
                      </div>
                    )}

                    {/* Active badge — unlock + pulse */}
                    {isActive && (
                      <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-[#F5C542] bg-[#F5C542] px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-[#04102A] shadow-lg">
                        <span className="relative flex h-2 w-2">
                          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#04102A] opacity-60" />
                          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#04102A]" />
                        </span>
                        Ativo agora
                      </div>
                    )}

                    {/* Revealed badge — trophy */}
                    {isRevealed && (
                      <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-[#F5C542] bg-[#F5C542] px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-[#04102A] shadow-lg">
                        <Trophy className="h-3.5 w-3.5" strokeWidth={2.6} />
                        Já saiu!
                      </div>
                    )}
                  </div>
                )}
                <div className="p-6">
                  {!c.img && <div className="text-3xl">{c.emoji}</div>}
                  <h3 className={`${c.img ? "" : "mt-4"} font-display text-xl font-black uppercase leading-tight tracking-tight text-white`}>
                    {c.title}
                  </h3>

                  {/* Status label */}
                  {c.statusLabel && (
                    <p
                      className={`mt-2 inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest ${
                        isActive || isRevealed ? "text-[#F5C542]" : "text-white/50"
                      }`}
                    >
                      {isRevealed ? (
                        <Trophy className="h-3.5 w-3.5" strokeWidth={2.6} />
                      ) : isActive ? (
                        <Unlock className="h-3.5 w-3.5" strokeWidth={2.6} />
                      ) : (
                        <Lock className="h-3.5 w-3.5" strokeWidth={2.6} />
                      )}
                      {c.statusLabel}
                    </p>
                  )}

                  <p className="mt-2 text-sm text-white/70">{c.text}</p>

                  {/* CTA - Confira quem ganhou */}
                  {isRevealed && (
                    <button
                      type="button"
                      onClick={() => {
                        setWinnerOpen(true);
                        if (typeof window !== "undefined" && typeof window.fbq === "function") {
                          window.fbq("trackCustom", "click_confira_ganhador");
                        }
                      }}
                      className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#F5C542] px-5 py-3 text-sm font-extrabold uppercase tracking-wide text-[#04102A] shadow-lg shadow-[#F5C542]/30 transition-transform hover:scale-[1.03]"
                      data-testid="btn-confira-ganhador"
                    >
                      <Trophy className="h-4 w-4" strokeWidth={2.6} />
                      Confira quem ganhou
                      <ArrowRight className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      {/* ================== BENEFÍCIOS ================== */}
      <section className="relative bg-gradient-to-b from-[#02081F] via-[#0A1F52] to-[#02081F] px-6 py-24 sm:py-32">
        <motion.div {...revealProps} className="mx-auto max-w-3xl text-center">
          <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
            Membros
          </p>
          <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl">
            Benefícios do Clube Dive Master
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
            Todos os membros têm acesso a estes benefícios{" "}
            <strong className="font-bold text-white">durante 1 ano</strong>. Os valores abaixo são{" "}
            <strong className="font-bold text-white">descontos aplicáveis sobre qualquer produto</strong>{" "}
            vendido no nosso site oficial durante esse período.
          </p>
        </motion.div>

        <motion.ul
          {...revealProps}
          className="mx-auto mt-14 grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2"
        >
          {BENEFITS.map((b) => (
            <li
              key={b}
              className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-md"
            >
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#7BE0D6]/15 text-[#7BE0D6]">
                <Check className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="text-sm font-semibold text-white/90 sm:text-base">{b}</span>
            </li>
          ))}
        </motion.ul>

        <motion.div {...revealProps} className="mt-14 flex flex-col items-center justify-center">
          <GreenCTA>Entrar no grupo VIP</GreenCTA>
          <CopyLinkButton testId="copy-vip-link-benefits" />
        </motion.div>
      </section>

      {/* ================== DIVERTRACK PREMIUM ================== */}
      <section
        id="divertrack"
        className="relative flex min-h-[100svh] items-center overflow-hidden bg-[#02050F] px-6 py-24 sm:py-32"
        data-testid="divertrack-section"
      >
        {/* Glow atrás da logo */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 50% 28%, rgba(59,130,246,0.35), transparent 45%), radial-gradient(circle at 50% 100%, rgba(37,99,235,0.15), transparent 60%)",
          }}
        />
        {/* Bolhas sutis */}
        <div
          className="pointer-events-none absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "radial-gradient(circle at 15% 80%, rgba(123,224,214,0.12) 0px, transparent 8px), radial-gradient(circle at 85% 60%, rgba(123,224,214,0.10) 0px, transparent 10px), radial-gradient(circle at 30% 30%, rgba(123,224,214,0.08) 0px, transparent 6px), radial-gradient(circle at 70% 20%, rgba(123,224,214,0.10) 0px, transparent 7px)",
          }}
        />

        <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center text-center">
          {/* Logo com glow */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.1, ease: EASE }}
            className="relative"
          >
            <div
              className="absolute inset-0 -z-10 blur-3xl"
              style={{
                background:
                  "radial-gradient(circle, rgba(59,130,246,0.55) 0%, transparent 70%)",
              }}
            />
            <img
              src="/images/divertrack-logo.png"
              alt="DiverTrack Premium"
              className="mx-auto h-40 w-auto object-contain drop-shadow-[0_0_40px_rgba(59,130,246,0.5)] sm:h-56"
            />
          </motion.div>

          {/* Wordmark DIVERTRACK PREMIUM */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
            className="mt-6 text-center"
          >
            <p className="font-display text-3xl font-black uppercase tracking-[0.18em] text-white sm:text-4xl">
              DiverTrack
            </p>
            <p className="mt-1 font-display text-xl font-black uppercase tracking-[0.4em] text-[#F5C542] sm:text-2xl">
              Premium
            </p>
          </motion.div>

          {/* Selo */}
          <motion.span
            {...revealProps}
            className="mt-10 inline-flex items-center gap-2 rounded-full border border-[#7BE0D6]/40 bg-[#7BE0D6]/10 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.28em] text-[#7BE0D6] backdrop-blur"
          >
            <Sparkles className="h-3.5 w-3.5" /> Benefício exclusivo para membros
          </motion.span>

          {/* Título */}
          <motion.h2
            {...revealProps}
            className="mt-8 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
          >
            Acesso antecipado ao <span className="text-[#7BE0D6]">DiverTrack Premium</span>
          </motion.h2>

          {/* Subtítulo */}
          <motion.p
            {...revealProps}
            className="mx-auto mt-6 max-w-2xl text-lg text-white/85 sm:text-xl"
          >
            Seu histórico de mergulho, suas certificações e sua comunidade em um só lugar.
          </motion.p>

          {/* Descrição */}
          <motion.p
            {...revealProps}
            className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg"
          >
            O DiverTrack é uma nova plataforma criada para transformar a forma como os
            mergulhadores registram e compartilham suas experiências. Como membro do Clube
            Dive Master, você terá acesso antecipado à versão Premium e poderá acompanhar
            toda a sua evolução no mergulho desde o início.
          </motion.p>

          {/* Cards de benefícios */}
          <div className="mx-auto mt-16 grid w-full max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                icon: BookOpen,
                title: "Logbook digital",
                text: "Registre seus mergulhos, destinos, profundidades, tempos e experiências de forma prática.",
              },
              {
                icon: Trophy,
                title: "Certificações organizadas",
                text: "Acompanhe seu histórico de cursos e certificações em um único perfil.",
              },
              {
                icon: Users2,
                title: "Comunidade de mergulhadores",
                text: "Compartilhe experiências, interaja com outros mergulhadores e descubra novos destinos.",
              },
              {
                icon: Zap,
                title: "Acesso Premium antecipado",
                text: "Faça parte desde o início de uma plataforma que tem tudo para se tornar a maior rede social de mergulho do Brasil.",
              },
            ].map((card, i) => (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
                className="group rounded-3xl border border-white/10 bg-white/[0.04] p-6 text-left backdrop-blur-md transition-all hover:border-[#3B82F6]/40 hover:bg-white/[0.07]"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#3B82F6]/15 text-[#7BE0D6] ring-1 ring-inset ring-[#3B82F6]/20">
                  <card.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-lg font-black uppercase leading-tight tracking-tight text-white">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70">{card.text}</p>
              </motion.div>
            ))}
          </div>

          {/* Frase final em destaque */}
          <motion.p
            {...revealProps}
            className="mx-auto mt-16 max-w-3xl font-display text-xl font-black uppercase leading-tight tracking-tight text-white/90 sm:text-2xl lg:text-3xl"
          >
            Mais do que registrar mergulhos.{" "}
            <span className="text-[#7BE0D6]">Uma nova forma de viver e compartilhar o oceano.</span>
          </motion.p>
        </div>
      </section>

      {/* ================== PHOTO STRIP CINEMATOGRÁFICO ================== */}
      <section className="relative overflow-hidden">
        <div className="grid grid-cols-2 gap-1 sm:grid-cols-4">
          {[
            { src: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&auto=format&fit=crop&q=75", alt: "Baleia" },
            { src: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&auto=format&fit=crop&q=75", alt: "Dubai" },
            { src: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800&auto=format&fit=crop&q=75", alt: "Tailândia" },
            { src: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&auto=format&fit=crop&q=75", alt: "Avião ao pôr do sol" },
          ].map((img) => (
            <div key={img.alt} className="relative aspect-square overflow-hidden bg-black sm:aspect-[3/4]">
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-full w-full object-cover opacity-90 transition-transform duration-1000 hover:scale-110 hover:opacity-100"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#02081F]/70 via-transparent to-transparent" />
            </div>
          ))}
        </div>
      </section>

      {/* ================== MUITO MAIS DO QUE SORTEIOS ================== */}
      <section className="relative px-6 py-24 sm:py-32">
        <motion.div {...revealProps} className="mx-auto max-w-3xl text-center">
          <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
            Comunidade
          </p>
          <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl">
            Muito mais do que sorteios.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg">
            O Clube Dive Master nasceu para reunir pessoas apaixonadas pelo mar. Além de participar
            de experiências inesquecíveis, você terá <strong className="text-white">benefícios
            exclusivos durante todo o ano</strong>, fará parte de uma comunidade ativa e receberá
            todas as novidades <strong className="text-white">antes de qualquer outra pessoa</strong>.
          </p>
        </motion.div>
      </section>

      {/* ================== BANNER PARADISE ================== */}
      <section className="relative h-[45svh] min-h-[320px] w-full overflow-hidden sm:h-[60svh]">
        <img
          src="https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=1800&auto=format&fit=crop&q=80"
          alt="Hospedagem de frente pro mar"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(2,8,31,0.25) 0%, rgba(2,8,31,0.6) 60%, rgba(2,8,31,0.95) 100%)",
          }}
        />
        <div className="relative z-10 flex h-full w-full items-end justify-center px-6 pb-10 sm:pb-14">
          <motion.p
            {...revealProps}
            className="max-w-3xl text-center font-display text-2xl font-black uppercase leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
          >
            O oceano nunca chamou tão alto.{" "}
            <span className="text-[#7BE0D6]">Vem com a gente.</span>
          </motion.p>
        </div>
      </section>

      {/* ================== POR QUE ENTRAR AGORA ================== */}
      <section className="relative bg-gradient-to-b from-[#02081F] via-[#0A1F52] to-[#02081F] px-6 py-24 sm:py-32">
        <motion.div {...revealProps} className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#ED2E24]/40 bg-[#ED2E24]/10 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.24em] text-[#ED2E24]">
            <Flame className="h-3.5 w-3.5" /> Urgência
          </span>
          <h2 className="mt-5 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-5xl">
            Por que entrar agora?
          </h2>
        </motion.div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2">
          {REASONS.map((r) => (
            <motion.div
              key={r.title}
              {...revealProps}
              className="flex items-start gap-4 rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-md"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#7BE0D6]/15 text-[#7BE0D6]">
                <r.icon className="h-5 w-5" />
              </span>
              <div>
                <h3 className="font-display text-lg font-black uppercase leading-tight tracking-tight text-white sm:text-xl">
                  {r.title}
                </h3>
                <p className="mt-1 text-sm text-white/70 sm:text-base">{r.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================== FAQ · SORTEIO ================== */}
      <section
        id="faq-sorteio"
        className="relative bg-gradient-to-b from-[#04102A] to-[#0A1F52] px-6 py-24 sm:py-32"
        data-testid="faq-sorteio-section"
      >
        <div className="mx-auto max-w-3xl">
          <motion.div {...revealProps} className="text-center">
            <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
              FAQ
            </p>
            <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-4xl">
              Como funciona o sorteio
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm text-white/70 sm:text-base">
              Transparência total. Nosso sorteio é baseado na Loteria Federal, evento
              oficial e auditado.
            </p>
          </motion.div>

          <div className="mt-12 space-y-4">
            <FaqStep
              n="1"
              title="Você recebe seus números da sorte por e-mail"
              text="Ao participar do clube, você recebe um bilhete com 10, 20 ou 40 números da sorte (dependendo do plano escolhido), gerados aleatoriamente e enviados diretamente no e-mail utilizado na compra."
            />

            <FaqStep
              n="2"
              title="Sorteio baseado na Loteria Federal"
              text="A realização dos nossos sorteios tem como base os eventos oficiais da Loteria Federal. No dia definido da premiação, a Loteria Federal sorteará 5 sequências de números, e sempre consideramos os 5 números."
            />

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <p className="text-[10px] font-black uppercase tracking-widest text-[#7BE0D6]">
                Exemplo dos números sorteados na Loteria Federal
              </p>
              <ul className="mt-3 space-y-1.5 font-mono text-sm text-white/90 sm:text-base">
                <li><span className="font-bold text-[#F5C542]">1º Prêmio</span> · 31544</li>
                <li><span className="font-bold text-white/60">2º Prêmio</span> · 61341</li>
                <li><span className="font-bold text-white/60">3º Prêmio</span> · 09129</li>
                <li><span className="font-bold text-white/60">4º Prêmio</span> · 13070</li>
                <li><span className="font-bold text-white/60">5º Prêmio</span> · 39900</li>
              </ul>
              <p className="mt-4 text-sm text-white/80">
                Nesse exemplo, o ganhador do sorteio de Abrolhos, Tailândia (ou outros prêmios)
                seria quem tivesse o número <span className="font-bold text-[#F5C542]">#31544</span>.
                Se ninguém tiver esse número, consideramos o 2º prêmio (#61341), depois 3º, 4º e
                5º — até encontrarmos um ganhador.
              </p>
            </div>

            <FaqStep
              n="3"
              title="E se ninguém tiver nenhum dos 5 números?"
              text="Nesse caso, o vencedor será a pessoa com o número da sorte mais próximo acima do 1º Prêmio da Loteria Federal."
            />

            <div className="rounded-2xl border border-[#7BE0D6]/40 bg-[#7BE0D6]/5 p-5 backdrop-blur-sm">
              <p className="text-[10px] font-black uppercase tracking-widest text-[#7BE0D6]">
                Exemplo prático
              </p>
              <p className="mt-3 text-sm text-white/85 sm:text-base">
                Se seu número da sorte for <span className="font-bold text-[#F5C542]">#31558</span> e
                ninguém tiver um número entre 31544 e 31558, você será o{" "}
                <span className="font-bold text-white">ganhador</span> — porque o seu é o mais próximo
                acima do 1º Prêmio da Loteria Federal (#31544).
              </p>
            </div>
          </div>

          <motion.div {...revealProps} className="mt-12 flex flex-col items-center justify-center">
            <GreenCTA>Entrar no grupo VIP</GreenCTA>
            <CopyLinkButton testId="copy-vip-link-faq" />
          </motion.div>
        </div>
      </section>

      {/* ================== REGULAMENTO ABROLHOS ================== */}
      <section
        id="regulamento-abrolhos"
        className="relative bg-[#02081F] px-6 py-20 sm:py-24"
        data-testid="regulamento-abrolhos-section"
      >
        <div className="mx-auto max-w-3xl">
          <motion.div {...revealProps} className="text-center">
            <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
              Regulamento
            </p>
            <h2 className="mt-3 font-display text-2xl font-black uppercase leading-tight tracking-tight sm:text-3xl lg:text-4xl">
              Regulamento da Premiação — Expedição Abrolhos para 2 Pessoas
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/70 sm:text-base">
              O prêmio consiste em <strong className="font-bold text-white">01 (uma) Expedição para o Arquipélago de Abrolhos</strong>{" "}
              para o ganhador e 01 (um) acompanhante, com duração de <strong className="font-bold text-white">4 dias e 3 noites</strong>,
              realizada mediante reserva antecipada, disponibilidade de vagas e conforme as condições deste regulamento.
            </p>

            <button
              type="button"
              onClick={() => {
                setRegulamentoOpen((v) => !v);
                if (
                  !regulamentoOpen &&
                  typeof window !== "undefined" &&
                  typeof window.fbq === "function"
                ) {
                  window.fbq("trackCustom", "open_regulamento_abrolhos");
                }
              }}
              aria-expanded={regulamentoOpen}
              aria-controls="regulamento-abrolhos-content"
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-full border border-[#7BE0D6]/40 bg-[#7BE0D6]/10 px-6 py-3 text-sm font-extrabold uppercase tracking-wide text-[#7BE0D6] backdrop-blur transition-all hover:border-[#7BE0D6]/70 hover:bg-[#7BE0D6]/20 sm:text-base"
              data-testid="toggle-regulamento-abrolhos"
            >
              {regulamentoOpen ? "Ocultar regulamento completo" : "Ver regulamento completo"}
              <ChevronDown
                className={`h-4 w-4 transition-transform ${
                  regulamentoOpen ? "rotate-180" : ""
                }`}
              />
            </button>
          </motion.div>

          <AnimatePresence initial={false}>
            {regulamentoOpen && (
              <motion.div
                key="regulamento-content"
                id="regulamento-abrolhos-content"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.5, ease: EASE }}
                className="overflow-hidden"
              >
                <div className="mt-12 space-y-6 text-left">
            {/* O prêmio inclui */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-[#7BE0D6]/30 bg-[#7BE0D6]/5 p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-[#7BE0D6] sm:text-xl">
                O prêmio inclui
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-white/85 sm:text-base">
                <li>✅ Expedição de 4 dias e 3 noites ao Arquipélago de Abrolhos.</li>
                <li>✅ Hospedagem durante toda a expedição (3 noites a bordo).</li>
                <li>✅ Alimentação completa durante toda a permanência na embarcação, conforme programação da expedição.</li>
                <li>✅ Passagens aéreas de ida e volta saindo da cidade de residência do ganhador, em qualquer localidade do Brasil, com destino a Porto Seguro (BA) ou Vitória (ES), conforme disponibilidade operacional.</li>
                <li>✅ Cobertura máxima de R$ 800,00 (oitocentos reais) por pessoa para as passagens aéreas, totalizando até R$ 1.600,00 para o ganhador e seu acompanhante.</li>
                <li>✅ Auxílio para o deslocamento terrestre entre Porto Seguro (BA) ou Vitória (ES) e Caravelas (BA) (ida e volta), com cobertura máxima de R$ 250,00 por participante, totalizando até R$ 500,00 para o ganhador e seu acompanhante.</li>
              </ul>
            </motion.div>

            {/* O prêmio não inclui */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-red-400/25 bg-red-500/[0.04] p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-red-300 sm:text-xl">
                O prêmio não inclui
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-white/85 sm:text-base">
                <li>❌ Hospedagem antes do embarque ou após o desembarque.</li>
                <li>❌ Alimentação fora do período da expedição, incluindo alimentação em aeroportos e durante deslocamentos.</li>
                <li>❌ Despesas com bagagens, excesso de peso, escolha de assentos, upgrades ou serviços adicionais das companhias aéreas.</li>
                <li>❌ Cursos de mergulho, certificações ou especialidades.</li>
                <li>❌ Equipamentos de mergulho.</li>
                <li>❌ Seguro viagem, despesas médicas, medicamentos, bebidas alcoólicas, compras, passeios extras ou quaisquer despesas pessoais.</li>
                <li>❌ Qualquer item não descrito expressamente como incluso neste regulamento.</li>
              </ul>
            </motion.div>

            {/* Utilização do prêmio */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-white sm:text-xl">
                Utilização do prêmio
              </h3>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-white/80 sm:text-base">
                <li>O prêmio poderá ser utilizado durante o ano de 2027, mediante reserva antecipada e disponibilidade de vagas.</li>
                <li>Não será válido para embarques nos períodos de Natal, Réveillon e feriados prolongados.</li>
                <li>A data da viagem deverá ser escolhida entre as expedições disponíveis da organização.</li>
              </ul>
            </motion.div>

            {/* Condições para mergulho */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-white sm:text-xl">
                Condições para mergulho
              </h3>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-white/80 sm:text-base">
                <li>Os mergulhos autônomos somente poderão ser realizados por participantes devidamente certificados.</li>
                <li>O prêmio não inclui curso de mergulho, certificação ou treinamento.</li>
                <li>Caso o ganhador ou acompanhante não sejam mergulhadores certificados, poderão participar normalmente da expedição como acompanhantes, aproveitando todas as atividades permitidas.</li>
              </ul>
            </motion.div>

            {/* Condições operacionais */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-white sm:text-xl">
                Condições operacionais
              </h3>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-white/80 sm:text-base">
                <li>O roteiro, número de mergulhos, locais visitados e programação poderão sofrer alterações em razão das condições climáticas, marítimas, operacionais ou de segurança, sem que isso gere direito à indenização ou compensação.</li>
                <li>Em caso de cancelamento da expedição por força maior ou condições climáticas, o prêmio será remarcado para outra data disponível.</li>
              </ul>
            </motion.div>

            {/* Condições gerais */}
            <motion.div
              {...revealProps}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm"
            >
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-white sm:text-xl">
                Condições gerais
              </h3>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-white/80 sm:text-base">
                <li>O prêmio é válido para 02 (duas) pessoas: o ganhador e um acompanhante.</li>
                <li>O prêmio é pessoal e não poderá ser convertido em dinheiro, crédito ou qualquer outra compensação financeira.</li>
                <li>Caso o valor das passagens aéreas ultrapasse R$ 800,00 por pessoa, a diferença será de responsabilidade do ganhador.</li>
                <li>Caso o custo do deslocamento terrestre entre o aeroporto e Caravelas ultrapasse R$ 250,00 por participante, a diferença será de responsabilidade do ganhador.</li>
                <li>O não comparecimento na data agendada implicará perda do prêmio, salvo autorização expressa da organização.</li>
                <li>A organização poderá solicitar documentos para emissão das passagens e reserva da expedição. Custos decorrentes de alterações solicitadas após a emissão dos bilhetes ou confirmações serão de responsabilidade do ganhador.</li>
                <li>Ao participar do Clube Dive Master, o participante declara estar ciente e de acordo com todas as condições deste regulamento.</li>
              </ul>
            </motion.div>
          </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </section>

      {/* ================== ÚLTIMA SEÇÃO ================== */}
      <section className="relative flex min-h-[92svh] items-center justify-center px-6 py-24">
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 50% 30%, rgba(59,130,246,0.25), transparent 60%), radial-gradient(ellipse at 50% 100%, rgba(37,211,102,0.12), transparent 60%)",
          }}
        />
        <motion.div
          {...revealProps}
          className="relative z-10 mx-auto flex max-w-3xl flex-col items-center text-center"
        >
          <img src={IMG.logo} alt="Dive Master" className="h-20 w-auto opacity-90 sm:h-24" />
          <h2 className="mt-10 font-display text-4xl font-black uppercase leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl">
            O oceano está esperando por você.
          </h2>
          <p className="mx-auto mt-6 max-w-lg text-base text-white/70 sm:text-lg">
            Clique abaixo e entre gratuitamente no grupo VIP da Dive Master.
          </p>
          <div className="mt-10 flex w-full flex-col items-center sm:w-auto">
            <GreenCTA size="xl">Entrar no grupo VIP do WhatsApp</GreenCTA>
            <CopyLinkButton testId="copy-vip-link-final" />
          </div>
        </motion.div>
      </section>

      {/* ================== MODAL: VENCEDOR ABROLHOS ================== */}
      <WinnerModal open={winnerOpen} onClose={() => setWinnerOpen(false)} />

      {/* ================== DOCUMENTOS LEGAIS (rodapé discreto) ================== */}
      <LegalDocsFooter />
    </main>
  );
}

function FaqStep({ n, title, text }) {
  return (
    <div className="flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F5C542] font-display text-lg font-black text-[#04102A]">
        {n}
      </span>
      <div>
        <h3 className="font-display text-lg font-black uppercase leading-tight tracking-tight text-white sm:text-xl">
          {title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-white/80 sm:text-base">{text}</p>
      </div>
    </div>
  );
}

